<template>
  <div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/2 w-full" v-if="$can('Cadastro por Marca', subjectPermission)">
        <vs-card class="mb-6">
          <div slot="header">
            <h3>Cadastro por Marca</h3>
          </div>
          <FormAddLista
            :tipo="tipo"
            tipoCadastro="Marca"
            :entidade="entidade"
            :pk="pk"
            @add="atualizaLista(true)"
          ></FormAddLista>
        </vs-card>
      </div>
      <div class="vx-col sm:w-1/2 w-full" v-if="$can('Cadastro por Modelo', subjectPermission)">
        <vs-card class="mb-6">
          <div slot="header">
            <h3>Cadastro por Modelo</h3>
          </div>
          <FormAddLista
            :tipo="tipo"
            tipoCadastro="Modelo"
            :entidade="entidade"
            :pk="pk"
            @add="atualizaLista(true)"
          ></FormAddLista>
        </vs-card>
      </div>
    </div>

    <vx-card>
      <ListListas
        :tipo="tipo"
        :novaBusca="novaBusca"
        tipoCadastro="Modelo"
        :entidade="entidade"
        :pk="pk"
        @pesquisado="atualizaLista(false)"
        :subjectPermission="subjectPermission"
      ></ListListas>
    </vx-card>
  </div>
</template>

<script>
import ListListas from "./../../lists/ListListas";
import FormAddLista from "./../../forms/FormListasByFipe";
export default {
  data() {
    return {
      tipo: "BlackListRastreador",
      entidade: "BlackListRastreador",
      pk: "idBlackListRastreador",
      novaBusca: false,
      subjectPermission: "Lista Rastreadores",
    };
  },
  methods: {
    atualizaLista(valor) {
      this.novaBusca = valor;
    },
  },
  components: {
    ListListas,
    FormAddLista,
  },
};
</script>
